export default [
  [`Европейские`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российские`, `42-44`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`],
  [`Высота по спинке (см)`, `68`, `70`, `72`, `74`, `76`, `78`],
  [`Ширина под проймой (см)`, `48`, `50`, `52`, `54`, `56`, `58`]
];
